import { MapPoint } from './vectorMap';

export type SceneEvent = { type: 'map'; points: MapPoint[] };

export interface SceneSnapshot {
    /** The memory map the scene draws, oldest point first; empty until loaded. */
    vectorMap: MapPoint[];
}

type Listener = (event: SceneEvent) => void;

let snapshot: SceneSnapshot = { vectorMap: [] };
const listeners = new Set<Listener>();

export const sceneSignals = {
    setVectorMap(points: MapPoint[]) {
        snapshot = { vectorMap: points };
        listeners.forEach((listener) => listener({ type: 'map', points }));
    },

    getSnapshot(): SceneSnapshot {
        return snapshot;
    },

    subscribe(listener: Listener): () => void {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
};
